import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import { ArticleModel, EpisodeModel } from '../../../network/rest';
import './style.scss';
import { links } from '../../../utils/staticContent';

interface Props {
    data: ArticleModel | EpisodeModel;
}

function ListItemWithDescription({ data }: Props) {
    return (
        <Link
            to={`${'showId' in data ? links.shows + `/${data.showId}` : links.articles}/${data.id}`}
            className="ListItemWithDescription"
        >
            <h2 className="title">
                {'episodeNumber' in data ? `EP ${data.episodeNumber} - ` : ''}
                {data.title}
            </h2>
            <div className="content">
                <div className="left-content">
                    {data.fileUrl && (
                        <img src={data.fileUrl as unknown as string} alt={data.title} />
                    )}
                </div>
                <div className="right-content">
                    {data.content
                        ? parse(data.content)
                        : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce sit amet porttitor metus. Aenean blandit nunc vitae tempus semper. Ut nisi eros, consectetur non erat id, sodales commodo nulla. Maecenas convallis consectetur massa, vitae lobortis ipsum consequat sit amet. '}
                </div>
            </div>
        </Link>
    );
}

export default ListItemWithDescription;
